import axios from "axios"

/**
 * ----------------------------------------------------
 * @path   /api/ping
 * @method GET
 * @desc   ping，用于检测网络是否存活
 * 
 * @date   2018-07-20 09:56:17
 * ----------------------------------------------------
 */
export function pingServer(obj) {
    return axios.get("/api/ping", {
        params: {
            "flag": Math.floor(Math.random() * 10000)
        }
    })
}